import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { VivaSpinnerComponent } from './viva-spinner.component';

@NgModule({
  declarations: [
    VivaSpinnerComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [
    VivaSpinnerComponent
  ]
})
export class  VivaSpinnerModule { }
